import { apiClient } from "./client";

export interface HourScenario {
  power_kw: number;
  volumes_kwh: Record<string, number>;
  cost_uah: number;
  cost_uah_per_mwh: number;
  revenue_uah: number;
  profit_uah: number;
}

export interface HourOptimum {
  hour: number;
  rdn_price_uah_per_mwh: number | null;
  best: HourScenario;
}

export interface DayOptimum {
  date: string;
  hours: HourOptimum[];
  total_optimal_profit_uah: number;
}

export interface HourDetail {
  hour: number;
  rdn_price_uah_per_mwh: number | null;
  scenarios: HourScenario[];
  best_index: number;
}

export interface RetroIntraday {
  date: string;
  hours: HourOptimum[];
  submitted_plan_profit_uah: number | null;
  optimal_profit_uah: number;
  lost_potential_uah: number | null;
}

export const optimizerApi = {
  day: (date: string) =>
    apiClient.get<DayOptimum>(`/optimizer/${date}`).then((r) => r.data),

  hour: (date: string, hour: number) =>
    apiClient
      .get<HourDetail>(`/optimizer/${date}/hour/${hour}`)
      .then((r) => r.data),

  retroIntraday: (date: string) =>
    apiClient
      .get<RetroIntraday>(`/optimizer/retro-intraday/${date}`)
      .then((r) => r.data),
};
